import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
html {
  box-sizing: border-box;
}

*,
::after,
::before {
  box-sizing: inherit;
}

body {
  font-family: "Roboto", sans-serif;
  background-image: url("https://ocdn.eu/pulscms-transforms/1/2C2k9kpTURBXy8wNGQ3MTQ0OGU4OWM1MTY1MjM0NDUxYTdjOTA0ZDdmZi5qcGeSlQMAzIzNB4DNBDiTBc0DmM0BzN4AAqEwBaExAQ");
  background-size: 100vw 100vh;
  font-size: 16px;
}
`;
